import { getAgreementH5 } from '@/api/login';
import { IObjStr, IObjStrObj } from '@/utils/http';
import scBrandLogoImg from '@/assets/img/pageOneSc/hbrlogo.png';

export const scBrandName = '荷包融';
export const scBrandLogo = scBrandLogoImg;
export const scBrandCompany = '成都稷韵信息科技有限公司';
export const scBrandIcp = '沪ICP备16038152号-8';

export const scRegisterAgreementName = '《用户注册服务协议》';
export const scPrivacyAgreementName = '《隐私政策》';
export const scShareAgreementName = '《个人信息共享授权书》';

export const findScAgreementList = (data: any): IObjStrObj[] => {
  if (Array.isArray(data)) return data as IObjStrObj[];
  if (data?.data) return findScAgreementList(data.data);
  return [];
};

export const normalizeScAgreementList = (data: any): IObjStrObj[] =>
  findScAgreementList(data)
    .map((item) => ({
      ...item,
      name: item.name || '',
      url: item.url || item.detailUrl || '',
    }))
    .filter((item) => item.name && item.url);

const findScAgreementByKeyword = (
  list: IObjStrObj[],
  keyword: string,
  displayName: string
): IObjStrObj | undefined => {
  const agreement = list.find((item) =>
    String(item.name || '')
      .replace(/\s/g, '')
      .includes(keyword)
  );
  return agreement ? { ...agreement, name: displayName } : undefined;
};

export const getScLoginAgreements = (data: any): IObjStrObj[] => {
  const list = normalizeScAgreementList(data);
  return [
    findScAgreementByKeyword(list, '用户注册服务协议', scRegisterAgreementName),
    findScAgreementByKeyword(list, '隐私政策', scPrivacyAgreementName),
  ].filter(Boolean) as IObjStrObj[];
};

export const getScShareAgreements = (data: any): IObjStrObj[] => {
  const agreement = findScAgreementByKeyword(
    normalizeScAgreementList(data),
    '共享授权书',
    scShareAgreementName
  );
  return agreement ? [agreement] : [];
};

export const getScDisplayPlatformAgreements = (data: any): IObjStrObj[] => {
  const list = normalizeScAgreementList(data);
  return [
    findScAgreementByKeyword(list, '用户注册服务协议', scRegisterAgreementName),
    findScAgreementByKeyword(list, '隐私政策', scPrivacyAgreementName),
    findScAgreementByKeyword(list, '共享授权书', scShareAgreementName),
  ].filter(Boolean) as IObjStrObj[];
};

const CREDIT_CONFIRM_KEYWORDS = ['贷款知情确认书', '对外提供授权'];

export const isScCreditConfirmAgreement = (name?: string) =>
  CREDIT_CONFIRM_KEYWORDS.some((key) =>
    String(name || '')
      .replace(/\s/g, '')
      .includes(key)
  );

const toScNamedAgreement = (item: IObjStrObj): IObjStr => {
  const url = String(item.url || item.detailUrl || '');
  const agreement: IObjStr = {
    name: String(item.name || ''),
    url,
    detailUrl: String(item.detailUrl || url),
  };
  if (item.id != null && item.id !== '') {
    agreement.id = String(item.id);
  }
  return agreement;
};

export const pickScCreditConfirmAgreements = (data: any): IObjStr[] =>
  normalizeScAgreementList(data)
    .filter((item) => isScCreditConfirmAgreement(item.name))
    .map(toScNamedAgreement);

// 荷包融网贷申请：用平台知情书替换产品「我方协议」里的优航链接，其它产品协议保留
export const mergeScCreditConfirmAgreements = (
  productList: IObjStrObj[] = [],
  platformList: IObjStr[] = []
): IObjStr[] => {
  const normalizedProductList = productList.map(toScNamedAgreement);
  if (!platformList.length) return normalizedProductList;
  const rest = normalizedProductList.filter((item) => !isScCreditConfirmAgreement(item.name));
  return [...platformList, ...rest];
};

export const getScCreditConfirmAgreements = async (
  platform = 'H5_SC_HEBAORONG',
  signingScenes: string[] = ['H5_ONLINE_APPLY', 'H5_CREDIT_CAPITAL']
): Promise<IObjStr[]> => {
  for (const signingScene of signingScenes) {
    try {
      const agreementRes = await getAgreementH5({ signingScene, platform });
      const list = pickScCreditConfirmAgreements(agreementRes);
      if (list.length) return list;
    } catch (err) {
      console.warn('获取荷包融知情协议失败', signingScene, err);
    }
  }
  return [];
};

export const scCreditConfirmFallback: IObjStr[] = [
  {
    name: '《贷款知情确认书》',
    url: 'https://protocol-pro.youhangjh.com/agreement/sc/hebaorong/dkzqqrs.html',
  },
  {
    name: '《个人信息对外提供授权书》',
    url: 'https://protocol-pro.youhangjh.com/agreement/sc/hebaorong/grxxdwtgsqs.html',
  },
];

export const fetchScLoginAgreements = async (): Promise<IObjStr[]> => {
  try {
    const agreementRes = await getAgreementH5({
      signingScene: 'H5_LOGIN',
      platform: 'H5_SC_HEBAORONG',
    });
    return getScLoginAgreements(agreementRes).map((item) => ({
      ...item,
      detailUrl: item.detailUrl || item.url,
    }));
  } catch (err) {
    console.warn('获取荷包融登录协议失败', err);
    return [];
  }
};
